module.exports = __webpack_public_path__ + "img/vr-space-mobile.6f5178db.jpg";